export default __webpack_public_path__ + "static/media/logo_tonfi.5fc48803.png";